import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import * as Sentry from "@sentry/react";
import {createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from "react-router-dom";

Sentry.init({
    dsn: "https://5ad81cb2b39e53e3191d5ce43f6b73fb@o4507476153073664.ingest.de.sentry.io/4507793270833232",
    environment: process.env.REACT_APP_ENV || "local",
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
        Sentry.replayIntegration({
            maskAllText: false,
            blockAllMedia: false,
            maskAllInputs: false,
            networkDetailAllowUrls: "leelaonline.net"

        }),
        Sentry.captureConsoleIntegration({levels: ['warn', 'error', 'assert']}),
        Sentry.contextLinesIntegration(),
        Sentry.extraErrorDataIntegration({depth: 5, captureErrorCause: true}),
        Sentry.httpClientIntegration(),
        Sentry.replayCanvasIntegration(),
        Sentry.feedbackIntegration({
            // Additional SDK configuration goes in here, for example:
            colorScheme: "system",
            showBranding: false,
            triggerLabel: "Підтримка / Support",
            formTitle: "Написати в службу підтримки / Contact us",
            nameLabel: "Ім'я / Name",
            namePlaceholder: "Ім'я / Name",
            emailLabel: "Імейл / Email",
            emailPlaceholder:"me@gmail.com",
            messageLabel: "Повідомлення / Message",
            messagePlaceholder: "",
            isRequiredLabel: "(обов'язково)",
            cancelButtonLabel: "Скасувати / Cancel",
            confirmButtonLabel:"Відправити / Send",
            submitButtonLabel:"Відправити / Sent",
            addScreenshotButtonLabel: "Додати знімок екрану / Add screenshot",
            removeScreenshotButtonLabel:"Видалити знімок екрану / Remove screenshot",
            successMessageText: "Дякую / Thank you"
        }),
    ],
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend(e) {
        if (
            e.message?.includes("silence detected on local audio track")
        ) {
            return null
        } else {
            return e
        }
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
